/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apartment_Times_HeadingInputs */

const en_apartment_times_heading = /** @type {(inputs: Apartment_Times_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arriving and leaving`)
};

/**
* | output |
* | --- |
* | "Arriving and leaving" |
*
* @param {Apartment_Times_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const apartment_times_heading = /** @type {((inputs?: Apartment_Times_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apartment_Times_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_apartment_times_heading(inputs)
});